<template>
    <div class="editLead">
        <Header :code="code">Edition d'un lead</Header>
        <LeadForm v-if="Object.keys(this.leadToEdit).length > 0" :lead="this.leadToEdit" @recordLead="editLead" @cancelForm="cancelForm"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import LeadForm from '@/components/LeadForm'
export default {
    name: 'EditLead',
    props: ['id', 'lead', 'code'],
    components: {
        Header,
        LeadForm
    },
    data() {
        return {
            leadToEdit: {}
        }
    },
    methods: {
        cancelForm(){
            this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
        },
        editLead(user){
            let leadToUpdate = {};
            leadToUpdate.code_lead = user.code_lead;
            leadToUpdate.data = {
                civilite : user.civilite,
                nom: user.nom,
                prenom: user.prenom,
                email: user.email,
                telephone_mobile: user.telephone_mobile,
                telephone_fixe: user.telephone_fixe,
                telephone_pro: user.telephone_pro,
                rue1: user.adresse.rue1,
                rue2: user.adresse.rue2,
                code_postal: user.adresse.code_postal,
                ville: user.adresse.ville,
                commentaire: user.commentaire,
                langue_preferee: user.langue_preferee,
                id_utilisateur: user.id
            }
             this.$store.dispatch('setLoader', true).then((e)=> {
                 this.$store.dispatch('updateLead', leadToUpdate).then((e)=> {
                     this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=>{
                        this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                            this.$store.dispatch('setLoader', false).then((e) => {
                                this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                            })
                        })
                        
                     })
                 })
             })
        }
    },
    computed: {

    },
    watch: {
    },
    created() {
         if(Object.keys(this.$store.state.detailLead).length === 0){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    const lead = this.$store.state.leads.find(e => e.id == this.id);
                    this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        if(this.$store.state.loader){
                            this.$store.dispatch('setLoader', false)
                        }
                        this.leadToEdit = this.$store.state.detailLead
                    }) 
                })                
            })
         } else {
            this.leadToEdit = this.lead
            if(this.$store.state.loader){
                this.$store.dispatch('setLoader', false)
            }
         }
        
    },
}
</script>
<style lang="scss">
    .editLead{
        padding-top: 8vh;
    }
    .account {
        font-size: 0.9em;
        h3 {
            font-size:1.4em;
        }
    }
</style>